export default __webpack_public_path__ + "static/media/cabinet1-after-480w.dcccee65.webp";